import { render, staticRenderFns } from "./entity-item.vue?vue&type=template&id=35268db9&scoped=true&"
import script from "./entity-item.vue?vue&type=script&lang=js&"
export * from "./entity-item.vue?vue&type=script&lang=js&"
import style0 from "./entity-item.vue?vue&type=style&index=0&id=35268db9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35268db9",
  null
  
)

export default component.exports